import { render } from "./Header.vue?vue&type=template&id=2f0a5b42&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2f0a5b42&lang=scss&scoped=true"

import exportComponent from "/home/forge/logistic.hoornbloommasters.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0a5b42"]])

export default __exports__